import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { SaveBoostInput_InputAdapter_instance21i6xmkt5f8zc as SaveBoostInput_InputAdapter_instance } from '../type/adapter/SaveBoostInput_InputAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SaveBoostMutation_VariablesAdapterClass;
function SaveBoostMutation_VariablesAdapter() {
  if (SaveBoostMutation_VariablesAdapterClass === VOID) {
    class $ {
      r6j(writer, value, customScalarAdapters, withDefaultValues) {
        writer.c4d('input');
        obj(SaveBoostInput_InputAdapter_instance).h40(writer, customScalarAdapters, value.q6j_1);
      }
    }
    initMetadataForObject($, 'SaveBoostMutation_VariablesAdapter');
    SaveBoostMutation_VariablesAdapterClass = $;
  }
  return SaveBoostMutation_VariablesAdapterClass;
}
var SaveBoostMutation_VariablesAdapter_instance;
function SaveBoostMutation_VariablesAdapter_getInstance() {
  return SaveBoostMutation_VariablesAdapter_instance;
}
//region block: init
SaveBoostMutation_VariablesAdapter_instance = new (SaveBoostMutation_VariablesAdapter())();
//endregion
//region block: exports
export {
  SaveBoostMutation_VariablesAdapter_instance as SaveBoostMutation_VariablesAdapter_instance19qfr21wtvqac,
};
//endregion

//# sourceMappingURL=SaveBoostMutation_VariablesAdapter.mjs.map
